var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('span',{staticClass:"app-header"}),_c('div',{staticClass:"container"},[_c('action-panel',{attrs:{"message":"404 Страница не найдена.","action-text":_vm.actionBtnText},on:{"action-click":_vm.backClick}}),_c('h2')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }